/**
 * Moved to `@sizzlenz/shared-frontend/providers`.
 * Re-exported here so existing `@/lib/contexts/KeyboardShortcutsContext` imports keep working.
 */
export {
  KeyboardShortcutsProvider,
  useKeyboardShortcuts,
  useKeyboardShortcut,
} from '@sizzlenz/shared-frontend/providers';
